/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useContext } from "react";
import Assert from "../../../../Basis/Utils/Assert";
import LaenderClient from "../../LaenderClient";
import Region from "../../Region";
import IRegionenContext from "./IRegionenContext";

export interface RegionenContextProps {
    children: React.ReactNode;
}

const regionenContext = React.createContext<IRegionenContext | null>(null);

export default function RegionenContext(props: RegionenContextProps) {
    const regionen = React.useRef<{ [landIso: string]: Region[] }>({});
    const laenderClient = new LaenderClient();

    const context = React.useMemo(() => ({
        async ermittleRegionen(landIso?: string): Promise<Region[]> {
            if (!landIso) {
                return [];
            }

            let regionenFuerLand = regionen.current[landIso];
            if (regionenFuerLand) {
                return regionenFuerLand;
            }

            regionenFuerLand = await laenderClient.ermittleRegionen({ landIso: landIso.toLowerCase() });
            regionen.current[landIso] = regionenFuerLand;
            return regionenFuerLand;
        }
    }), []);

    return (
        <regionenContext.Provider value={context}>
            {props.children}
        </regionenContext.Provider>
    );
}

export function useRegionenContext(): IRegionenContext {
    const context = useContext(regionenContext);
    return Assert.notNull(context, "useRegionenContext kann nur innerhalb des RegionenContexts verwendet werden!");
}
